export const sanitizeFieldName = (label: string): string => {
	return (
		label
			// Replace spaces, commas and dots with underscores
			.replace(/[\s,.]/g, '_')
			// Replace special characters and symbols
			.replace(/[&/#,+()$~%'":*?<>{}]/g, '')
			// Replace multiple consecutive underscores with a single one
			.replace(/_+/g, '_')
			// Convert to lowercase
			.toLowerCase()
			// Remove underscores at start and end
			.replace(/^_+|_+$/g, '')
	)
}
